import { Button } from '@bridebook/aura';
import { Copy, Check } from '@bridebook/aura/src/icons';
import { useCopyToClipboardWithFeedback } from '@bridebook/web/lib/utils/hooks/use-copy-to-clipboard-with-feedback';
import { useShareWeddingWebsiteClick } from '@bridebook/web/lib/wedding-website/analytics/use-share-wedding-website-click';
import { ComponentProps } from 'react';

type Props = Pick<ComponentProps<typeof Button>, 'disabled'> & {
  text: string;
};
export const CopyToClipboardButton = ({ disabled, text }: Props) => {
  const { isCopied, copy } = useCopyToClipboardWithFeedback();

  const { trackShareWeddingWebsiteClick } = useShareWeddingWebsiteClick();

  const handleCopy = () => {
    copy(text);
    trackShareWeddingWebsiteClick({
      cta: 'Copy link',
      clickedLocation: 'weddingWebsitesDesktop',
    });
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleCopy}
      icon={isCopied ? Check : Copy}
      disabled={disabled}
    />
  );
};
